export const contactData = [
  {
    name: "Gokul Gopinath",
    phone: "+91 9961899106",
    role: "Lead Organizer"
  },
  {
    name: "Archana Sivadasan",
    phone: "+91 8078562186",
    role: "Lead Organizer"
  },
  {
    name: "Aswin Santhosh",
    phone: "+91 7306266635",
    role: "Event operation manager"
  },
  {
    name: "Harikrishnan M R",
    phone: "+91 7306253427",
    role: "Event operation manager"
  },
  {
    name: "Aston Raju",
    phone: "+91 8921578893",
    role: "Activities and Event Planner"
  },
  {
    name: "Email",
    email: "tekothonsahrdaya@gmail.com",
    role: "For queries"
  }
];
